<template>
  <div class="file-select-upload">
    <draggable
      :list="fileList"
      class="show-line"
      ghost-class="ghost"
      @start="dragging = true"
      @end="handleDrag"
    >
      <div v-for="(item, index) in fileList" :key="index">
        <div
          :class="{
            'show-img': true,
            'checked-image': checkIndex == index,
          }"
        >
          <img
            class="display-img"
            :src="item.pictureUrl | getImgById"
            alt=""
            style="object-fit:cover;"
            @click="checkFile(index)"
          />
          <img
            v-if="showCheckIcon"
            class="select-check-icon"
            src="@/assets/images/select-icon.png"
          />
          <div
            v-if="!denyAll && !isReplaceMode"
            class="remove"
            @click="removeFile(index)"
          >
            <i class="el-icon-circle-close"></i>
          </div>
        </div>
        <el-button
          class="update-img"
          v-if="showUpdate && checkIndex == index"
          size="small"
          @click="showUpdateImageDialog(index)"
        >
          更换图片
        </el-button>
      </div>
      <div
        v-show="fileList.length < limitNumber"
        v-if="!denyAll && !(singleSelectType && fileList.length >= 1)"
        class="upload-img"
        @mouseover="onMouseOver('imageShow')"
        @mouseout="onMouseOut('imageShow')"
      >
        <div
          v-show="imageShow"
          class="relocating"
          @click="showSelectedDialogFile('s')"
        ></div>
        <div style="flex-shrink: 0;    width: 80px;">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </draggable>

    <!-- <div
      v-show="fileList.length < limitNumber"
      v-if="!denyAll && !(singleSelectType && fileList.length >= 1)"
      class="upload-img"
      @mouseover="onMouseOver('imageShow')"
      @mouseout="onMouseOut('imageShow')"
    >
      <div
        v-show="imageShow"
        class="relocating"
        @click="showSelectedDialogFile('s')"
      ></div>
      <div style="flex-shrink: 0;    width: 80px;">
        <i class="el-icon-plus"></i>
      </div>
    </div> -->

    <material-selection-dialog
      ref="showSelectedImage"
      :material-type="CONST.MATERIAL_TYPE.img"
      :limit="img_num"
      :is-multi="isMulti"
      @selected="handleSelectedFile"
    />
  </div>
</template>

<script>
import MaterialSelectionDialog from '@/components/material-selection-dialog/material-selection-dialog.vue';
import { getCommonHeaders } from '@/utils/request';
export default {
  name: 'FileSelectUpload',
  components: { MaterialSelectionDialog },
  props: {
    limitNumber: {
      type: Number,
      default: 100,
    },
    propFileList: {
      type: Array,
      default: () => [],
    },
    singleSelectType: {
      type: Boolean,
      default: false,
    },
    showCheckIcon: {
      type: Boolean,
      default: false,
    },
    showUpdate: {
      type: Boolean,
      default: false,
    },
    isReplaceMode: {
      type: Boolean,
      default: false,
    },
    afterUploadFun: {
      type: Function,
      default: () => {},
    },
    canRemove: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      CONST,
      actionUrlCustom:
        this.$http.defaults.baseURL + '/business/common/file/uploadPandV',
      imageShow: false,
      img_num: 1,
      fileList: this.propFileList,
      denyAll: false, //    禁止编辑所有
      dragging: false,
      checkIndex: 0,
      updateIndex: -1,
    };
  },
  computed: {
    uploadHeaders() {
      return {
        ...getCommonHeaders(),
        ContentType: 'multipart/form-data',
      };
    },
    isMulti() {
      return (
        !this.singleSelectType && this.img_num > 1 && this.updateIndex === -1
      );
    },
  },
  watch: {
    propFileList: {
      immediate: true,
      handler: function(newVal, oldVal) {
        this.fileList = newVal;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.denyAll = !!this.$route.query.scan;
  },
  methods: {
    handleDrag(e) {
      this.dragging = false;
      this.$emit('sortFile', this.fileList, e);
    },
    removeFile(index) {
      const deleteFile = this.fileList[index];
      this.fileList.splice(index, 1);
      this.$emit('deleteFile', {
        index,
        current: deleteFile,
      });
      this.$emit('update:propFileList', _.cloneDeep(this.fileList));
    },
    checkFile(index) {
      const selectFile = this.fileList[index];
      if (this.isReplaceMode) {
        this.showSelectedDialogFile();
        return;
      } else {
        this.$emit('checkFile', {
          index,
          current: selectFile,
        });
        this.checkIndex = index;
      }

      //  todo
      // this.$emit('update:propFileList', _.cloneDeep(this.fileList));
    },
    showSelectedDialogFile() {
      this.updateIndex = -1;
      this.img_num = this.limitNumber - this.fileList.length;
      this.$refs.showSelectedImage.open();
    },
    showUpdateImageDialog: function(index) {
      this.img_num = 1;
      this.updateIndex = index;
      this.$refs.showSelectedImage.open();
    },
    onMouseOver(type) {
      this[type] = true;
    },
    onMouseOut(type) {
      this[type] = false;
    },
    handleSelectedFile(data) {
      if (data.materialSize > 3 * 1024 * 1024) {
        return this.$message.warning('图片不可大于3M');
      }
      if (this.updateIndex > -1) {
        this.fileList[this.updateIndex] = data;
      } else {
        if (this.isReplaceMode) {
          this.fileList = [];
        }
        if (Array.isArray(data)) {
          const url = [];
          for (const val of data) {
            url.push(val);
          }
          this.fileList = [...this.fileList, ...url];
        } else {
          this.fileList = [...this.fileList, data];
        }
      }
      this.afterUploadFun();
      this.$emit('selectFile', data, this.updateIndex);
      this.$emit('update:propFileList', _.cloneDeep(this.fileList));
    },
  },
};
</script>

<style lang="scss" scoped>
.file-select-upload {
  display: flex;
}
.show-line {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-shrink: 0;
  max-width: 300px;
}
.upload-img {
  height: 80px;
  width: 80px;
  border: 1px dashed red;
  border-radius: 5px;
  margin-right: 20px;
  margin-top: 20px;
  position: relative;
  input {
    display: none;
  }
  .relocating {
    height: 80px;
    width: 80px;
    border-radius: 5px;
    position: absolute;
    left: 0px;
    top: 0px;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px 0px;
    div {
      height: 30px;
      line-height: 30px;
      width: 80px;
      border-radius: 5px;
      background: white;
      cursor: pointer;
    }
  }
  .bg {
    background-color: rgb(240, 199, 199);
  }
  div {
    display: flex;
    justify-content: center;
  }
  span {
    line-height: 30px;
  }
  i {
    font-size: 26px;
    line-height: 26px;
    color: red;
    margin-top: 15px;
  }
  .el-icon-plus {
    height: 80px;
    line-height: 80px;
    margin-top: 0px;
  }
}
.show-img {
  position: relative;
  height: 80px;
  width: 80px;
  border-radius: 5px;
  margin-right: 20px;
  margin-top: 20px;
  border: 1px dashed rgba(255, 0, 0, 0.082);
  &:hover {
    .remove {
      display: inline;
    }
  }
  img {
    height: 80px;
    width: 80px;
    border-radius: 5px;
    cursor: pointer;
  }
  .select-check-icon {
    width: 40px !important;
    height: 40px !important;
    position: absolute;
    bottom: -3px;
    right: -3px;
    display: none;
  }

  .remove {
    display: none;
    position: absolute;
    top: -16px;
    right: -16px;
    height: 28px;
    width: 28px;
    cursor: pointer;
    color: $themeColor;

    i {
      font-size: 25px;
    }
  }
}
.checked-image .select-check-icon {
  display: block;
}
.update-img {
  height: 30px;
  font-size: 12px;
  margin-top: 10px;
}
</style>
